module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paySucc"
  }, [_c('div', {
    staticClass: "con"
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v("支付成功")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.toRecharge
    }
  }, [_vm._v(" 确定" + _vm._s(_vm.roomid))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6e129e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dating/paySucc.vue
// module id = 126
// module chunks = 0